import { chatRequest } from '../../service/ChatService';
export const translationApi = (path, method, body, signal) => chatRequest(path, { method, body, signal });
